const sharedCardData = {
  1: {
    name: "Capital One Venture X",
    image: "/Cards/capitaloneventure.avif",
    annualFee: 395,
    hotOffer: false,
    applyLink: "https://i.capitalone.com/JSfMput1x",
    bonus:
      "Earn 75,000 bonus miles once you spend $5,000 on purchases within the first 6 months from account opening",
    historicHighestBonus:
      "100,000 bonus miles when you spend $5,000 on purchases in the first three months from account opening",
  },
  2: {
    name: "AMEX Hilton Aspire Card",
    image: "/Cards/hilton.webp",
    annualFee: 550,
    hotOffer: true,
    applyLink:
      "https://americanexpress.com/en-us/referral/hilton-honors?ref=DONGFZrGSC&xl=cp19",
    bonus:
      "Earn 175,000 Hilton Honors Bonus Points With the Hilton Honors American Express Aspire Card after you spend $3,000 in purchases on the Card within your first 6 months of Card Membership",
    historicHighestBonus:
      "New Hilton Honors Aspire card members can earn 175,000 Hilton points after spending $6,000 on purchases with your card in the first six months of card membership.",
  },
  3: {
    name: "Marriott Bonvoy Brilliant® American Express® Card",
    image: "/Cards/marriott.avif",
    annualFee: 650,
    hotOffer: true,
    applyLink:
      "https://americanexpress.com/en-us/referral/marriott-bonvoy?ref=DONGFZx4w3&xl=cp19",
    bonus:
      "Earn 200,000 points after spending $6,000 in eligible purchases within the first six months",
    historicHighestBonus:
      "Earn 200,000 points after spending $6,000 in eligible purchases within the first six months ",
  },
  4: {
    name: "AMEX Gold Card",
    image: "/Cards/amexgold.avif",
    annualFee: 325,
    hotOffer: true,
    applyLink:
      "https://americanexpress.com/en-us/referral/gold-card?ref=DONGFZYnJj&XLINK=MYCP",
    bonus:
      "Earn up to 100,000 Membership RewardsÂ® PointsThis offer was previously 60,000 after you spend $6,000 on purchases on your new Card in your first 6 months of Card Membership.",
    historicHighestBonus:
      "Earn 100,000 Membership RewardsÂ® PointsThis offer was previously 60,000 after you spend $6,000 on purchases on your new Card in your first 6 months of Card Membership.",
  },
  5: {
    name: "Chase Sapphire Preferred®",
    image: "/Cards/chasecsp.png",
    annualFee: 95,
    hotOffer: false,
    applyLink: "https://www.referyourchasecard.com/19v/XWMN16AZGU",
    bonus:
      "Earn 75,000 bonus points after spending $5,000 in the first three months of account opening.",
    historicHighestBonus:
      "Earn 100,000 bonus points after spending $4,000 in the first three months of account opening.",
  },
  6: {
    name: "Chase Sapphire Reserve",
    image: "/Cards/chasecsr.png",
    annualFee: 795,
    hotOffer: true,
    applyLink: "https://www.referyourchasecard.com/19v/O7Z5DIESE7",
    bonus:
      "Earn 125,000 bonus points after $6,000 in purchases in your first 3 months from account opening.*",
    historicHighestBonus:
      "Earn 125,000 bonus points after $6,000 in purchases in your first 3 months from account opening.*",
  },
  7: {
    name: "Chase Amazon Prime Visa",
    image: "/Cards/chaseamazon.png",
    annualFee: 0,
    hotOffer: false,
    applyLink:
      "https://www.amazon.com/dp/BT00LN946S?externalReferenceId=f4471963-ae19-4ba8-90f3-3febda2657a3",
    bonus:
      "Get a $150 Amazon Gift Card instantly upon approval with an eligible Prime membership",
    historicHighestBonus:
      "Get a $250 Amazon Gift Card instantly upon approval with an eligible Prime membership",
  },
  8: {
    name: "Chase Southwest Rapid Rewards Priority Card",
    image: "/Cards/chasesouthwest.png",
    annualFee: 229,
    hotOffer: false,
    applyLink: "https://www.referyourchasecard.com/226c/60A3VEYTHF",
    bonus:
      "Earn 85000 bonus points after you spend 4000$ on purchase in the first 3 months from account opening",
    historicHighestBonus:
      "Earn 100000 bonus points after you spend 4000$ on purchase in the first 3 months from account opening",
  },
  9: {
    name: "Chase Southwest Rewards Performance Business Card",
    image: "/Cards/chasesouthwestbusiness.png",
    annualFee: 299,
    hotOffer: false,
    applyLink: "https://www.referyourchasecard.com/226c/IRD5KZELCC",
    bonus:
      "Earn 80,000 bonus points after you spend $5,000 on purchases in the first 3 months from account opening.",
    historicHighestBonus:
      "Earn 120,000 bonus points with Southwest Rapid Rewards Business Credit Card",
  },
  10: {
    name: "Bank of America® Customized Cash Rewards",
    image: "/Cards/bankofamerica.jpeg",
    annualFee: 0,
    hotOffer: false,
    applyLink:
      "https://www.bankofamerica.com/credit-cards/products/cash-back-credit-card/",
    bonus:
      "Online $200 cash rewards bonus after making at least $1,000 in purchases in the first 90 days of your account opening",
    historicHighestBonus:
      "Online $200 cash rewards bonus after making at least $1,000 in purchases in the first 90 days of your account opening",
  },
  11: {
    name: "Fidelity Visa Signature Rewards",
    image: "/Cards/fidelity.png",
    annualFee: 0,
    hotOffer: false,
    applyLink: "https://www.fidelity.com/go/visa-signature-rewards-1502",
    bonus:
      "Receive 15,000 Bonus Points â€“ which equals $150 cash back, when deposited into an eligible Fidelity account - after you make at least $1,000 in eligible net purchases withing the first 90 days of account opening.",
    historicHighestBonus:
      "Receive 15,000 Bonus Points â€“ which equals $150 cash back",
  },
  12: {
    name: "Chase Freedom Flex",
    image: "/Cards/chasefreedom.png",
    annualFee: 0,
    hotOffer: false,
    applyLink: "https://www.referyourchasecard.com/18s/H8PV7FBNN3",
    bonus:
      "Earn a 200$ bonus after spending $500 on purchases in your first 3 months from account opening",
    historicHighestBonus:
      "Earn $250 back after spending $500 on purchases in the first three months from account opening, plus earn 5% back on grocery store purchases on up to $12,000 spent during the first year.",
  },
  // 13: {
  //   name: "Bilt Credit Card",
  //   image: "/Cards/Bilt.png",
  //   annualFee: 0,
  //   hotOffer: false,
  //   applyLink: "",
  // },
  14: {
    name: "AMEX Platinum Card",
    image: "/Cards/amexplatinum.avif",
    annualFee: 895,
    hotOffer: true,
    applyLink:
      "https://americanexpress.com/en-us/referral/platinum-card?ref=YUANZXhXe&xl=cp19",
    bonus:
      "Spend $8,000 in purchases on their new Card in the first 6 months of Card and get 175000 Membership RewardsÂ® Points.",
    historicHighestBonus:
      "Spend $8,000 in purchases on their new Card in the first 6 months of Card and get 175000 Membership RewardsÂ® Points.",
  },
}

export default sharedCardData
